/*
  Challenge 1
  Draw a zig-zag
 */

// Utils
var $ = require ('jquery');
var videoSequence = require('../lib/video-promise');
var shapeMatchViewFactory = require('./shapeMatchViewFactory');

// Video
var mainVideo = document.getElementById('mainVideo');
var replaySequence = videoSequence(mainVideo, "0:00:18:07", "0:00:20:07");

// Fail and Success views
var uioptions = {
  uiclasses: {
    icon: "icon--challenge1",
    number: "icon-number--1",
    gesture: "icon-gesture--scrub"
  }
};
var failFactory = require('../lib/fail');
var failView = failFactory(replaySequence, uioptions);
var successFactory = require('../lib/success');
var successView = successFactory(uioptions);

// DOM
var $wrapper = $('#appendHere');
var template = require('../templates/challenge1.hbs');
var $html = $(template());
var canvas = $html.find('#challenge1')[0];

var view = shapeMatchViewFactory({
  $wrapper : $wrapper,
  $html : $html,
  canvas : canvas,
  matchShape : "zig-zag",
  failView : failView,
  successView : successView
});

module.exports = view;
